<template>
  <div>
    <v-sheet elevation="1" color="#57bc90" style="min-height: 70vh">
      <v-col>
        <v-data-table
          dense
          :headers="headers"
          :items="upcomingGames"
          class="elevation-1"
        >
          <!-- date time -->
          <template v-slot:item.dateAndTime="{ item }">
            <p class="caption">
              {{ item.dateAndTime | dayFormat }}
            </p>
          </template>
          <!-- date time -->

          <!-- game week -->
          <!-- <template v-slot:item.gameWeek="{ item }">
            <p class="caption">
              {{ item.gameWeek | dayFormat }}
            </p>
          </template> -->
          <!-- game week -->
        </v-data-table>
      </v-col>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "UpcomingGames",
  props: {
    upcomingGames: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      headers: [
        // {
        //   text: 'Game Week',
        //   value: 'gameWeek',
        //   sortable: false,
        // },
        {
          text: "Date and Time",
          value: "dateAndTime",
          sortable: false,
        },
        {
          text: "Opponent Team",
          value: "oppTeam",
        },
        { text: "TV Channel", value: "tvChannel" },
        // { text: 'Weather', value: 'weather' },
      ],
    };
  },
};
</script>

<style scoped></style>
